<template>
  <div id="chart" style="width: 100%; height: 550px"></div>
</template>

<script>
import echarts from "echarts";

const percentage = [];

// 生成0-100的百分比
for (let index = 0; index <= 100; index++) {
  percentage[index] = index;
}
// const time = []
// for (let index = 0; index <= 3000; index++) {
//   let arr = []
//   let string = "0.0"
//   arr = string.split('')
//   if (index % 100 == 0) {
//     arr[0] = (index / 100) * 2
//   } else {
//     arr[0] = Math.trunc((index / 100) * 2)
//     arr[2] = ((index * 2) % 100)  < 10 ? '0' + ((index * 2) % 100) : ((index * 2) % 100)
//   }
//   string = arr.join('')
//   time[index] = string
// }
export default {
  name: "BlinkChart",
  components: {},
  props: {
    // blhArray: {
    //   type: Array,
    //   default: []
    // },
    // timeArray: {
    //   type: Array,
    //   default: []
    // },
    resblhArray: {
      type: Array,
      default: []
    },
    language: {
      type: String,
      default: ""
    },
    currentEye: {
      type: String,
      default: "OS"
    },
    realTotalTime: {
      type: Number
    },
    record: {
      type: Object
    }
  },
  data() {
    return {
      myChart: null,
      blinkData: [],
      blinkDataeList: [],
      blinkValueList: [],
      chartOptions: {
        backgroundColor: "#2d3039",
        color: "#93969f",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            snap: false
          },
          formatter: `${this.$t("langcfg.txtBlinkQuality")}: {c0}%<br/>${this.$t("langcfg.txtTime")}: {b0}`,
          backgroundColor: "#fff",
          textStyle: {
            color: "#000"
          },
          hideDelay: 1500
          //提示框位置
          // position: function (pt) {
          //   return [pt[0], 50];
          // }
        },
        xAxis: [
          {
            axisLabel: {
              interval: 49,
              // show: false,
              color: "#93969f",
              formatter: function (value, index) {
                return Number(value);
              }
            },
            axisLine: {
              //x轴线的颜色以及宽度
              // show: false,
              lineStyle: {
                color: "#93969f",
                width: 2
              }
            },
            axisTick: {
              // show: false,
              lineStyle: {
                color: "#93969f"
              }
            },
            axisPointer: {
              lineStyle: {
                width: 3,
                height: 20,
                cap: "round",
                snap: false
              }
            },
            color: "#93969f",
            boundaryGap: false,
            data: []
            // gridIndex: 0,
            // min: "00'00",
            // max: "60'00"
          }
        ],
        yAxis: [
          {
            type: "value",
            boundaryGap: false,
            color: "#93969f",
            name: this.$t("langcfg.txtBlinkQuality"),
            nameTextStyle: {
              //y轴上方单位的颜色
              color: "#98979c"
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              interval: 24,
              color: "#93969f",
              formatter: "{value}%"
            },
            axisLine: {
              //y轴线的颜色以及宽度
              show: true,
              lineStyle: {
                color: "#93969f",
                width: 2
              }
            },
            axisTick: {
              lineStyle: {
                color: "#93969f"
              }
            },
            data: percentage,
            // gridIndex: 0,
            min: 0,
            max: 100
          }
        ],
        grid: [
          {
            // show: true,
            left: "2.5%",
            width: "97%",
            height: "35%",
            bottom: "59%"
          }
        ],
        series: [
          {
            type: "line",
            smooth: true,
            name: this.$t("langcfg.txtBlinkQuality"),
            showSymbol: false,
            data: [],
            xAxisIndex: 0,
            yAxisIndex: 0,
            markLine: {
              itemStyle: {
                color: "#8bb748"
              },
              symbol: "none",
              label: {
                normal: {
                  // position: "end",
                  formatter: ""
                }
              },
              data: [{ yAxis: "75" }] // 虚线的数据
            }
          }
        ]
      },
      isLanguage: "",
      currentTime: ""
    };
  },
  created() {
    this.createdChart();
    this.isLanguage = window.settings.language;
    this.chartOptions.tooltip.formatter = `${this.isLanguage === "de" ? this.$t("langcfg.txtBlink") : this.$t("langcfg.txtBlinkQuality")}: {c0}%<br/>${this.$t("langcfg.txtTime")}: {b0}`;
    this.chartOptions.yAxis[0].name =
      this.isLanguage === "de" ? this.$t("langcfg.txtBlink") : this.$t("langcfg.txtBlinkQuality");
    if (this.isLanguage === "it") this.chartOptions.yAxis[0].nameTextStyle.align = "left";
    this.chartOptions.series[0].name =
      this.isLanguage === "de" ? this.$t("langcfg.txtBlink") : this.$t("langcfg.txtBlinkQuality");
    // this.myChart.setOption(this.chartOptions);
    const { blink } = this.record.content[`data${this.currentEye}`];
    if (blink.videoTime) {
      this.currentTime = blink.videoTime;
    } else {
      this.currentTime = this.realTotalTime;
    }
  },
  mounted() {
    this.initChart();
    window.onresize = this.myChart.resize;
    this.$bus.$on("video-time", (time) => {
      time = Number(time) > 60 ? 60 : Number(time);
      if (this.myChart) {
        let xData = [];
        for (let index = 0; index <= time * 50; index++) {
          let arr = [];
          let str = "0.0";
          arr = str.split("");
          if (index % 100 == 0) {
            arr[0] = (index / 100) * 2;
          } else {
            arr[0] = Math.trunc((index / 100) * 2);
            arr[2] = (index * 2) % 100 < 10 ? "0" + ((index * 2) % 100) : (index * 2) % 100;
          }
          str = arr.join("");
          xData[index] = str;
        }
        this.myChart.setOption({
          xAxis: {
            data: xData
          }
        });
      }
    });
    this.$bus.$emit("video-time", this.currentTime);
  },
  updated() {
    this.isLanguage = window.settings.language;
  },
  methods: {
    initChart() {
      if (this.myChart == null) {
        this.myChart = echarts.init(document.getElementById("chart"), "dark");
        // this.setSeries()
        this.myChart.setOption(this.chartOptions);
      }
    },
    createdChart() {
      if (window.__dryeye__.debug && this.resblhArray.length <= 0) {
        // 生成一分钟的眨眼假数据
        this.blinkData = [];
        let length = this.currentEye === "OD" ? 3001 : 3001;
        for (let index = 0; index < length; index++) {
          this.blinkData[index] = [];
          this.blinkData[index][0] = Math.floor(Math.random(1, 100) * 100);
        }
      } else {
        this.blinkData = [];
        for (let index = 0; index < this.resblhArray.length; index++) {
          this.blinkData[index] = [];
          this.blinkData[index][0] = this.resblhArray[index]
            ? (this.resblhArray[index].toFixed(2) * 100).toFixed()
            : 0.3;
        }
      }
      this.blinkValueList = this.blinkData.map(function (item) {
        return item[0];
      });
      this.chartOptions.series[0].data = this.blinkValueList;
    }
  },
  watch: {
    language: function () {
      // var option = this.myChart.getOption();
      this.chartOptions.tooltip.formatter = `${this.language === "de" ? this.$t("langcfg.txtBlink") : this.$t("langcfg.txtBlinkQuality")}: {c0}%<br/>${this.$t("langcfg.txtTime")}: {b0}`;
      this.chartOptions.yAxis[0].name =
        this.language === "de" ? this.$t("langcfg.txtBlink") : this.$t("langcfg.txtBlinkQuality");
      if (this.language === "it") this.chartOptions.yAxis[0].nameTextStyle.align = "left";
      this.chartOptions.series[0].name =
        this.language === "de" ? this.$t("langcfg.txtBlink") : this.$t("langcfg.txtBlinkQuality");
      this.myChart.setOption(this.chartOptions);
      this.$bus.$emit("video-time", this.currentTime);
    },
    currentEye() {
      this.createdChart();
      this.myChart.setOption(this.chartOptions);
      this.$bus.$emit("video-time", this.currentTime);
    }
  },
  computed: {},
  destroyed() {
    this.$bus.$off("video-time");
  },
  beforeDestory() {
    if (this.myChart) {
      this.myChart.dispose();
      this.myChart = null;
    }
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/dryeye/components/BlinkChart.vue